
<template>
  <!-- <div> -->
    <v-card style="border-radius:12px">
      <v-card-title primary-title>
          <div class="headline mb-0">{{one_supplier.id? (let_edit? "Editando fornecedor" : "Detalhes de fornecedor") : "Novo fornecedor"}}</div>
          <v-spacer></v-spacer>
          <v-btn small v-if="one_supplier.id" fab :color="let_edit? 'error' : 'primary'" class="elevation-0" @click="toggleEdit()"><v-icon>{{let_edit? 'mdi-close' :'mdi-pencil'}}</v-icon></v-btn>
          <v-col cols="12" class="py-0" v-if="!let_edit">
            <v-chip  small :color="'#'+(0x1000000+(Math.random())*0xffffff).toString(16).substr(1,6)" class="ma-1" style="text-transform:capitalize;" v-for="(tag, index) in one_supplier.tag_list" :key="index">{{tag}}</v-chip>
          </v-col>
        <!-- flat or icon are good to 1.5, fab or text are good to 2.0 -->
      </v-card-title>
      <v-card-text>
        <v-form ref="formSupplier" v-model="valid" lazy-validation>
          <template>
            <v-container v-if="let_edit || !one_supplier.id" fluid>
              <v-combobox  v-model="one_supplier.tag_list" :items="tags.list" :search-input.sync="tags.search" hide-selected hint="Máximo de 5 tags" label="Adicione algumas tags" multiple persistent-hint small-chips>
                <template v-slot:no-data v-if="tags.search">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        Não foram encontrado resultados para " <strong>{{ tags.search }}</strong>". Pressione <kbd>enter</kbd> para criar uma nova tag
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-combobox>
            </v-container>
          </template>
          <v-row align="center">
            <v-divider></v-divider>
            <v-subheader class="primary--text">Dados básicos</v-subheader>
            <v-divider></v-divider>
          </v-row>
          <v-text-field type="text" :readonly="!let_edit" :rules="[rules.required]" v-model="one_supplier.name" prepend-icon="mdi-account-tie" label="Nome"></v-text-field>
          <v-text-field :readonly="!let_edit" :rules="[rules.required, rules.email]" v-model="one_supplier.email" prepend-icon="mdi-email" label="Email"></v-text-field>
          <v-dialog v-model="dialog_adress" persistent max-width="500px">
            <template v-slot:activator="{ on }">
              <v-text-field readonly v-on="let_edit? on : ''" :value="one_supplier.addresses.full_address" prepend-icon="mdi-map-marker" label="Endereço"></v-text-field>
            </template>
            <card-address v-if="dialog_adress" :address.sync="one_supplier.addresses" @address-sent="one_supplier.addresses = $event, dialog_adress=false"></card-address>
          </v-dialog>

          <v-radio-group :readonly="!let_edit" mandatory v-model="one_supplier.is_natural" row>
            <v-radio :value="true" color="success">
              <template v-slot:label>
                <div><strong class="success--text">Pessoa Física</strong></div>
              </template>
            </v-radio>
            <v-radio :value="false" color="secondary">
              <template v-slot:label>
                <div><strong class="secondary--text">Pessoa Jurídica</strong></div>
              </template>
            </v-radio>
          </v-radio-group>

          <template v-if="!one_supplier.is_natural">
            <v-row align="center">
              <v-divider></v-divider>
              <v-subheader class="primary--text">Dados corporativos</v-subheader>
              <v-divider></v-divider>
            </v-row>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.corporate_info.corporate_name" prepend-icon="mdi-domain" label="Razão Social"></v-text-field>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.corporate_info.state_inscription" prepend-icon="mdi-information" label="Inscrição estadual"></v-text-field>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.corporate_info.city_inscription" prepend-icon="mdi-information" label="Inscrição municipal"></v-text-field>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.document" prepend-icon="mdi-account-card-details" v-mask='mask_cnpj' :label="'CNPJ'"></v-text-field>
          </template>

          <template v-if="one_supplier.is_natural">
            <v-text-field :readonly="!let_edit" v-model="one_supplier.document" prepend-icon="mdi-account-card-details" v-mask='mask_cpf' :label="'CPF'"></v-text-field>   
          </template>

          <template>
            <!-- CAN BE A COMPONENT IF NEEDES ELSEWHERE -->
            <v-row align="center">
              <v-divider></v-divider>
              <v-subheader class="primary--text">Dados bancários</v-subheader>
              <v-divider></v-divider>
            </v-row>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.bank_account.bank" prepend-icon="mdi-bank" label="Banco"></v-text-field>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.bank_account.account" prepend-icon="mdi-information" label="Nº Conta"></v-text-field>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.bank_account.agency" prepend-icon="mdi-information" label="Agência"></v-text-field>
            <v-radio-group :readonly="!let_edit" mandatory v-model="one_supplier.bank_account.kind" row>
              <v-radio value="current" color="primary">
                <template v-slot:label>
                  <div><strong class="primary--text">Conta Corrente</strong></div>
                </template>
              </v-radio>
              <v-radio value="saving" color="blue">
                <template v-slot:label>
                  <div><strong class="blue--text">Conta Poupança</strong></div>
                </template>
              </v-radio>
            </v-radio-group>
            <v-text-field :readonly="!let_edit" v-model="one_supplier.bank_account.titular" prepend-icon="mdi-account-circle" label="Titular"></v-text-field>
            <v-divider></v-divider>
          </template>
          
          <input-phone :phones.sync="one_supplier.phones" :is_readonly="!let_edit"></input-phone>
          <v-alert v-if="one_supplier.phones.length == 0 || one_supplier.phones[0].length == 0" type="error" :value="true">
            Necessário ao menos um telefone de contato
          </v-alert>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn text color="error" @click="emitClose()">Cancelar</v-btn>
        <v-btn text color="primary" @click="submitSupplier()">Salvar</v-btn>
      </v-card-actions>
    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>
    </v-card>
  

  <!-- </div> -->
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '../../api/index'
import { mask } from 'vue-the-mask'

export default {
  name: 'SupplierProfile',
  props: {
    one_supplier: {
      type: Object,
    },
    dialog_supplier: {
      type: Boolean,
    },
  },
  components: {
    IndexTable: () => import('@/components/shared/IndexTable'),
    InputPhone: () => import('@/components/shared/InputPhone'),
    CardAddress: () => import('@/components/shared/CardAddress'),
  },
  directives: {
    mask,
  },
  data() {
    return {
      let_edit: false,

      loading: false,
      loadingText: null,

      mask_cnpj: '##.###.###/####-##',
      mask_cpf: '###.###.###-##',
      rules: {
        required: v => !!v || 'Campo é necessário',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 14) || 'CPF deve ser completo',
      },
      valid: true,
      dialog_adress: false,

      tags:{
        list: [],
        selected:[], 
        search: null
      }

    }
  },
  methods: {
    emitClose(){
      this.$emit('close', false)
    },
    fetchTags(){
      Api.Tag.index({model: "Supplier"})
          .then(r=>r.data)
          .then(tags=>{
            // console.log({tags})
            this.tags.list = tags
            
          }).catch(err=>{
            this.loading = false
            this.loadingText = null
            console.log('Erro em index de tags')
            console.log({err})
          })
    },
    toggleEdit(){
      this.let_edit = !this.let_edit
      if(this.let_edit){
        this.tags.copy = this.one_supplier.tag_list.map(o => o.charAt(0).toUpperCase() + o.slice(1))
        this.one_supplier.tag_list = this.tags.copy
        this.fetchTags()
      }else{
        this.one_supplier.tag_list = this.tags.copy
        this.tags = {
        ...this.tags,
        selected:[],
        copy: null,
        search: null,
      }
      }
    },
    submitSupplier(){
      if (this.$refs.formSupplier.validate() && this.one_supplier.phones.length > 0) {
        this.loading = true
        this.loadingText = "Salvando"
        console.log('is valid');
        if (!this.one_supplier.id) {
          // console.log('create');
          this.createSupplier(this.one_supplier)
          this.loading = true
        } else {
          this.updateSupplier(this.one_supplier)
        }
        
      } else {
        console.log('not valid');

      }
    },
    ...mapActions({
      createSupplier: 'Supplier/create',
      updateSupplier: 'Supplier/update',
    })
  },
  mounted () {
    if(!this.one_supplier.id){
      this.let_edit = true
    }
    if(this.dialog_supplier){
      this.fetchTags()
    }
    // this.let_edit = this.one_supplier.id? false : true
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      createSupplierWasGood: state => state.Supplier.createSupplierWasGood,
      createSupplierMessage: state => state.Supplier.createSupplierMessage,

      updateSupplierWasGood: state => state.Supplier.updateSupplierWasGood,
      updateSupplierMessage: state => state.Supplier.updateSupplierMessage,
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    },
    createSupplierWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {          
          this.loading = false
          this.loadingText = null
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Fornecedor ${this.oneClient.name} criado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.emitClose()
        }, 1200);
      } else if (nv == false){
        this.loading = false
        this.loadingText = null
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 8000,
          showConfirmButton: false,
          title: `Erro: ${this.createSupplierMessage.name}`,
          type: "error",
        })
      }
    },
    updateSupplierWasGood(nv,ov) {
      if (nv){
        setTimeout(() => {          
          this.loading = false
          this.loadingText = null
          this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Fornecedor ${this.one_supplier.name} editado com sucesso`,
            type: "success",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          this.emitClose()
        }, 1200);
      } else if (nv == false){
        this.loading = false
        this.loadingText = null
        this.$swal({
          toast: true,
          position: 'top-end',
          timer: 8000,
          showConfirmButton: false,
          title: `Erro: ${this.updateSupplierMessage}`,
          type: "error",
        })
      }
    }
  },
}
</script>

<style scoped>

</style>